import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getDashboardTicketsCount } from "../../api/casp/dashboard";
import { withTranslation } from "react-i18next";

const ApexColumnBarChartProjectSatus = ({ projectId, t }) => {
  const [ticketsCount, setTicketsCount] = useState()

  useEffect(() => {
    fetchTaskCount()
  }, [])

  /** Fetch milestone list from api */
  const fetchTaskCount = async () => {
    try {
      const res = (await getDashboardTicketsCount(projectId)).data.data;
      const allCountsNonZero = res?.values?.every(item => item.count === 0);
      const labels = []
      const values = []
        if (res.labels.length > 0) {
          res.labels.forEach(item => {
          labels.push(item.name)
          })
        } 
      if (res.values.length > 0) {
        if(!allCountsNonZero){
          res.values.forEach(item => {
            values.push(item.count)
            })
        }
        
      } 
      setTicketsCount({
          labels: labels,
          values: values
      })
    } catch (error) {
      console.log(error);
    }
  };

  const data = {
    series: ticketsCount?.values?.length?
    [
      {
        name: 'counts',
        data: ticketsCount.values
      }
    ]
    : [],
    options: {
      chart: {
        type: "bar",
        height: 280,
      },
      noData: {
        text: t('No data found'),
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: 'black',
          fontSize: '16px',
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ticketsCount?.labels,
        title: {
          text: t("Project’s Status"),
        },
        labels: {
          rotate: -90,
          rotateAlways: true,
          trim: true,
          hideOverlappingLabels: true,
          show: true,
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: t("Counts"),
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
            
        },
        x: {
          show: true
        },
      },
    },
  };

  return (
    <>
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={350}
      />
    </>
  );
}
export default withTranslation() (ApexColumnBarChartProjectSatus);